module.exports = __webpack_public_path__ + "static/media/playstore.606c39db.png";